import Switch from "@mui/material/Switch";
import type { FilterRange as Range } from "./filter-logic";
import { RangeSlider } from "./RangeSlider";

// PORT OF `filter-range`: A `card w-full` WITH THE BOLD `text-lg` TITLE AND AN ENABLE SWITCH,
// THEN (`mt-5`) THE RANGE SLIDER, DISABLED WHILE THE SWITCH IS OFF. THE POINTERS SHOW THE
// FILTER'S OWN MIN / MAX (SEE THE REPORT: ANGULAR SHOWS THE FULL FLOOR..CEIL INSTEAD).
export function FilterRange(props: {
  title: string;
  data: Range;
  // `FormatterType`: "$" FOR DOLLARS, "" FOR THE DURATION (ANGULAR PASSES `formatter=""`)
  formatter: string;
  minValue: number;
  maxValue: number;
  minLabel: string;
  maxLabel: string;
  onChange: (data: Range) => void;
}) {
  const { title, data, formatter, minValue, maxValue, minLabel, maxLabel, onChange } = props;
  return (
    <div className="card w-full">
      <div className="flex flex-row align-items-center justify-content-between">
        <div className="font-bold text-lg">{title}</div>
        <div>
          <Switch checked={data.enabled} onChange={(_, enabled) => onChange({ ...data, enabled })} slotProps={{ input: { "aria-label": title } }} />
        </div>
      </div>
      <div className="mt-5">
        <RangeSlider
          floor={minValue}
          ceil={maxValue}
          min={data.min}
          max={data.max}
          disabled={!data.enabled}
          prefix={formatter}
          minLabel={minLabel}
          maxLabel={maxLabel}
          ariaLabel={title}
          onChange={(min, max) => onChange({ ...data, min, max })}
        />
      </div>
    </div>
  );
}
